<template>
  <div class="irp-contacts-count-cell">
    <BittsTag
      v-if="commonCount"
      :text="`${commonCount} Common`"
      color="secondary"
      size="x-small"
    />
    <BittsTag
      v-if="newCount"
      :text="`${newCount} New`"
      color="neutral"
      size="x-small"
    />
    <span
      v-if="!commonCount && !newCount"
      class="irp-contacts-count-cell__empty"
      >&mdash;</span
    >
  </div>
</template>

<script setup lang="ts">
import { BittsTag } from '@crossbeam/bitts';

import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const commonCount = computed(() => params.data?.contacts_common_count ?? 0);
const newCount = computed(() => params.data?.contacts_new_count ?? 0);
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-contacts-count-cell {
  @apply flex items-center h-full w-full;
}

.irp-contacts-count-cell__empty {
  @apply text-neutral-text-weak;
}

.irp-contacts-count-cell .bitts-tag .ant-tag {
  @apply mr-4 whitespace-nowrap;
}
</style>
